'use client';

import { ExpressiveButton } from './expressive-button/expressive-button';
import { HeaderLoginButton } from './navigation/HeaderRedesignLoginButton';
import { breakpoints } from '@thrivent/midwest-shared';
import styled from 'styled-components';

export const ResponsiveContainer = styled.div`
  max-width: 90rem;
  margin: 0 auto;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 0.375rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${breakpoints.tablet} {
    padding: 1rem 2rem;
  }
  ${breakpoints.desktop} {
    align-items: flex-start;
    flex-direction: column;
    padding: 2rem 1rem;
  }
  @media screen and (min-width: 1280px) {
    flex-direction: row;
    justify-content: flex-start;
    padding: 2rem 3rem;
    gap: 2rem;
  }
  @media screen and (min-width: 1280px) {
    flex-direction: row;
    justify-content: flex-start;
    padding: 2rem 1rem;
  }
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  ${breakpoints.desktop} {
    width: 100%;
    justify-content: space-between;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HeaderNav = styled.div`
  display: none;
  ${breakpoints.desktop} {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-right: 1rem;
  }
`;

export const HeaderButtons = styled.div`
  ${breakpoints.desktop} {
    display: none;
  }
`;

export const HeaderButtonsDesktop = styled.div`
  display: none;
  text-wrap: nowrap;
  ${breakpoints.desktop} {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }
`;

export const FindAnFAButton = styled(ExpressiveButton)``;

export const Container = styled.div`
  top: 0;
  z-index: 598;
  background: ${(p) => p.theme.midwestColors.white};
  border-bottom: none;
`;

export const LoginButtonContainer = styled.div`
  max-width: 5rem;
  ${breakpoints.desktop} {
    display: none;
  }
`;

export const LoginButton = styled(HeaderLoginButton)``;
